<script>
    import { Accounts } from "meteor/accounts-base";

    let currentPassword = $state("");
    let newPassword = $state("");
    let confirmPassword = $state("");
    let message = $state("");
    let errorMessage = $state("");
    let saving = $state(false);

    function resetForm() {
        currentPassword = "";
        newPassword = "";
        confirmPassword = "";
    }

    function changePassword(event) {
        event.preventDefault();
        message = "";
        errorMessage = "";

        if (newPassword.length < 10) {
            errorMessage = "New password must be at least 10 characters.";
            return;
        }

        if (newPassword !== confirmPassword) {
            errorMessage = "New passwords do not match.";
            return;
        }

        saving = true;
        Accounts.changePassword(currentPassword, newPassword, (error) => {
            saving = false;

            if (error) {
                errorMessage = error.reason || "Password could not be changed.";
                return;
            }

            resetForm();
            message = "Password changed.";
        });
    }
</script>

<section class="settings-page">
    <h1>Settings</h1>

    <div class="settings-panel">
        <h2>Change Password</h2>
        <form class="settings-form" onsubmit={changePassword}>
            <label
                >Current Password<input
                    required
                    type="password"
                    autocomplete="current-password"
                    bind:value={currentPassword}
                /></label
            >
            <label
                >New Password<input
                    required
                    type="password"
                    autocomplete="new-password"
                    bind:value={newPassword}
                /></label
            >
            <label
                >Confirm New Password<input
                    required
                    type="password"
                    autocomplete="new-password"
                    bind:value={confirmPassword}
                /></label
            >
            <button type="submit" disabled={saving}>
                {saving ? "Changing..." : "Change Password"}
            </button>
            {#if errorMessage}<p class="error">{errorMessage}</p>{/if}
            {#if message}<p class="success">{message}</p>{/if}
        </form>
    </div>
</section>
